import {
    Alert,
    Box,
    Chip,
    Divider,
    Icon,
    IconButton,
    Typography,
} from "@mui/material";
import { useContext } from "react";
import { useSelector } from "react-redux";
import { SubscriptionTypesDefintions } from "../../../constants/SubscriptionConstants";
import { DialogContext } from "../../../contexts/DialogueContext";
import { RootState } from "../../../slices/Store";
import { toJalaliDate } from "../../../utils/date";

// updated
export default function ProjectDetailDesktopHeader() {
    const projectDetailState = useSelector(
        (state: RootState) => state.projectDetail
    );
    const projectDetail = projectDetailState.projectDetail;

    const { closeDialog } = useContext(DialogContext);

    const constructorViewInfo =
        projectDetailState.projectDetail?.constructorViewInfo;

    const handleCloseDialog = () => {
        closeDialog();
    };

    const projectRequiredSubscriptionType = SubscriptionTypesDefintions.find(
        (s) => s.type === projectDetail.requiredSubscriptionType
    );

    return (
        <Box>
            <Box
                sx={{
                    bgcolor: "background.paper",
                    display: "flex",
                    px: 2,
                    height: 50,
                    alignItems: "center",
                }}
            >
                <Box sx={{ flexGrow: 1 }}>
                    <IconButton onClick={handleCloseDialog}>
                        <Icon>close</Icon>
                    </IconButton>
                </Box>

                <Chip
                    size="small"
                    label={projectRequiredSubscriptionType?.title ?? "-"}
                    color="primary"
                />

                <Typography
                    sx={{ ml: 2 }}
                    color="text.secondary"
                >
                    شناسه: {projectDetail.hashId}
                </Typography>
            </Box>

            <Divider sx={{ mb: 2 }} />

            {projectDetailState.projectDetail.isVisited && (
                <Alert
                    sx={{ mb: 2, mx: 2 }}
                    variant="standard"
                    severity="info"
                    icon={<Icon>person</Icon>}
                >
                    {`این پروژه توسط
                     ${constructorViewInfo.user?.displayName}
                     در تاریخ
                     ${toJalaliDate(constructorViewInfo.visitDate)}
                     دیده شده است.`}
                </Alert>
            )}
        </Box>
    );
}
